module.exports = __webpack_public_path__ + "static/media/sound-bubble-pause.1f24a6bc.png";